import { Checkbox } from '@cian/ui-kit';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { PIK_PROMO } from 'shared/constants/specialPromos';
import { useAppDispatch, useFilterChangeCallback } from 'shared/hooks';
import { selectSpecialPromoFilter } from 'shared/selectors/advancedFilters';
import { setNeedUpdateGeoTags } from 'shared/slices/tags';
import { TModifier } from 'shared/types/filters';

export const SpecialPromoContainer: FC = () => {
  const dispatch = useAppDispatch();

  const { label, value, visible, developerId } = useSelector(selectSpecialPromoFilter);

  const onChange = useFilterChangeCallback();

  const handleSpecialPromoChange = useCallback(
    (isSpecialPromoActive: boolean | null) => {
      if (!developerId) {
        return;
      }

      if (isSpecialPromoActive) {
        const modifiers: [TModifier, ...TModifier[]] = [
          { action: 'selectGeo', arguments: [{ type: 'builder', id: developerId }] },
          { action: 'setBuilders', arguments: [developerId] },
        ];

        if (developerId === PIK_PROMO.developerId) {
          modifiers.push({ action: 'setPikPromo', arguments: [true] });
        }

        onChange(...modifiers);
        dispatch(setNeedUpdateGeoTags(true));
      } else {
        const modifiers: [TModifier, ...TModifier[]] = [
          { action: 'removeGeo', arguments: [{ type: 'builder', id: developerId }] },
          { action: 'setBuilders', arguments: [null] },
        ];

        if (developerId === PIK_PROMO.developerId) {
          modifiers.push({ action: 'setPikPromo', arguments: [null] });
        }

        onChange(...modifiers);
      }
    },
    [developerId, dispatch, onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <InlineFilterGroup>
      <InlineFilter>
        <Checkbox
          label={label}
          checked={!!value}
          onChange={event => handleSpecialPromoChange(event.target.checked ? true : null)}
        />
      </InlineFilter>
    </InlineFilterGroup>
  );
};
